import { BalanceMessage as BalanceMessageResponse } from "../../api/HomePageResponseTypes";
import { Classifier } from "../../util/classifierManager";
import { DateString } from "../../util/conversionUtils";

export interface BalanceMessage extends Omit<BalanceMessageResponse, "liik" | "alamliik" | "lopetatud"> {
  liik: Classifier;
  alamliik: Classifier;
  lopetatud: DateString;
}

export enum ColumnHeader {
  proceedingNr = "proceedingNr",
  proceedingType = "proceedingType",
  proceedingSubtype = "proceedingSubtype",
  finisher = "finisher",
  finished = "finished",
}

export const ColumnNameMap = new Map<ColumnHeader, keyof BalanceMessage>([[ColumnHeader.proceedingType, "liik"]]);
